import React from 'react'
import { Link } from 'react-router-dom'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { Translate, I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import MenuItem from 'material-ui/Menu/MenuItem'
import classNames from 'classnames'
import _ from 'lodash'

import Loading from 'components/loading'
import passportFImageUrl from 'assets/images/ico_passportF.svg'
import passportBImageUrl from 'assets/images/ico_passportB.svg'
import withKyc from '../../../hocs/kyc'
import ValidationErrors from '../validation_errors'
import Group from '../group'
import Submit from '../submit'

const Kyc = ({ current_user, initialValues }) => (
  <div>
    <h2>{I18n.t('users.kyc.h')}</h2>
    <h3 className="text-center">{I18n.t('users.kyc.h3')}</h3>
    {current_user.kyc_verification &&
      current_user.kyc_verification === 'in_progress' && (
        <div>
          <div className="submited-mark">
            <span>
              <i className="fa fa-check" />
            </span>{' '}
            {I18n.t('users.kyc.submitted')}
          </div>
          <br />
          <div className="thank-text">
            <p dangerouslySetInnerHTML={{ __html: I18n.t('users.kyc.submitted_html') }} />
          </div>
          <br />
          <br />
          <Grid container>
            <Grid item xs />
            <Grid item xs={4}>
              <Button raised color="primary" className="wide" component={Link} to="/deposits">
                {I18n.t('users.kyc.next')}
              </Button>
            </Grid>
            <Grid item xs />
          </Grid>
        </div>
      )}
    {current_user.kyc_verification &&
      current_user.kyc_verification === 'approved' && (
        <div>
          <div className="approved-mark">
            <span>
              <i className="fa fa-check" />
            </span>{' '}
            {I18n.t('users.kyc.approved')}
          </div>
          <br />
          <div className="thank-text">
            <p>{I18n.t('users.kyc.approved_text')}</p>
          </div>
          <br />
          <br />
          <Grid container>
            <Grid item xs />
            <Grid item xs={4}>
              <Button raised color="primary" className="wide" component={Link} to="/deposits">
                {I18n.t('users.kyc.next')}
              </Button>
            </Grid>
            <Grid item xs />
          </Grid>
        </div>
      )}
    {current_user.kyc_verification &&
      current_user.kyc_verification === 'rejected' && (
        <div>
          <div className="rejected-mark">
            <span>
              <i className="fa fa-check" />
            </span>{' '}
            {I18n.t('users.kyc.rejected')}
          </div>
          <br />
          <div className="thank-text">
            <p>{I18n.t('users.kyc.rejected_text')}</p>
            {initialValues && <p>{initialValues.deny_reason}</p>}
          </div>
        </div>
      )}

    {(!current_user.kyc_verification ||
      !_.includes(['in_progress', 'approved'], current_user.kyc_verification)) && <KycReduxForm />}
  </div>
)

const CustomFileInput = ({ id, input }) => {
  delete input.value
  return <input type="file" id={id} {...input} style={{ display: 'none' }} />
}

const KycForm = ({
  error,
  submitting,
  handleSubmit,
  countries,
  document_front,
  document_back,
  document_selfie,
  loading
}) => (
  <form onSubmit={handleSubmit}>
    <Loading active={loading}>
      <br />
      <br />
      {error && <ValidationErrors errors={JSON.parse(error)} />}
      <br />
      <Grid container direction="column">
        <Grid item>
          <Grid container>
            <Grid item md={4} xs={12}>
              <Field
                name="first_name"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.first_name')}
                required
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Field
                name="middle_name"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.middle_name')}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Field
                name="last_name"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.last_name')}
                required
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item md={3} xs={12}>
              <Field
                name="phone"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.phone_number')}
                placeholder="+99999999999"
                required
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <Field
                name="dob"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.date_of_birth')}
                placeholder="YYYY-MM-DD"
                required
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <Field
                select
                component={Group}
                name="country_code"
                label={I18n.t('users.kyc.country')}
                required
              >
                {_.map(countries, ({ name, alpha3 }) => (
                  <MenuItem key={alpha3} value={alpha3}>
                    {name}
                  </MenuItem>
                ))}
              </Field>
            </Grid>
            <Grid item md={3} xs={12}>
              <Field
                select
                component={Group}
                name="citizenship"
                label={I18n.t('users.kyc.citizenship')}
                required
              >
                {_.map(countries, ({ name, alpha3 }) => (
                  <MenuItem key={alpha3} value={alpha3}>
                    {name}
                  </MenuItem>
                ))}
              </Field>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item md={4} xs={12}>
              <Field
                name="address_line_1"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.address_line_1')}
                required
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Field
                name="address_line_2"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.address_line_2')}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Field
                name="address_line_3"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.address_line_3')}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item md={4} xs={12}>
              <Field name="state" type="text" component={Group} label={I18n.t('users.kyc.state')} />
            </Grid>
            <Grid item md={4} xs={12}>
              <Field
                name="city"
                type="text"
                component={Group}
                label={I18n.t('users.kyc.city')}
                required
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Field
                select
                component={Group}
                name="gender"
                label={I18n.t('users.kyc.gender')}
                required
              >
                {_.map(
                  {
                    male: I18n.t('users.kyc.male'),
                    female: I18n.t('users.kyc.female'),
                    other: I18n.t('users.kyc.other')
                  },
                  (text, value) => (
                    <MenuItem key={value} value={value}>
                      {text}
                    </MenuItem>
                  )
                )}
              </Field>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br />
      <br />
      <div
        className="alert alert-dismissible alert-warning"
        dangerouslySetInnerHTML={{ __html: I18n.t('users.kyc.documents_alert_html') }}
      />

      <div>
        <Grid container>
          <Grid item md={6} xs={12}>
            <Field
              name="document_number"
              type="text"
              component={Group}
              label={I18n.t('users.kyc.document_number')}
              required
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Field
              select
              component={Group}
              name="document_type"
              label={I18n.t('users.kyc.document_type')}
              required
            >
              {_.map(
                {
                  passport: I18n.t('users.kyc.passport'),
                  national_identity_card: I18n.t('users.kyc.national_identity_card'),
                  driving_licence: I18n.t('users.kyc.driving_licence')
                },
                (text, value) => (
                  <MenuItem key={value} value={value}>
                    {text}
                  </MenuItem>
                )
              )}
            </Field>
          </Grid>
        </Grid>
        <br />
      </div>

      <div className="document-check">
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <Field
              id="document_front"
              name="document_front"
              type="file"
              component={CustomFileInput}
              required
            />
            <label
              htmlFor="document_front"
              className={classNames('item', { passed: document_front })}
            >
              <span>
                <img src={passportFImageUrl} alt="" />
                <i className="fa fa-check" />
              </span>
              <p>{I18n.t('users.kyc.document_front')}</p>
            </label>
          </div>
          <div className="col-md-6 col-xs-12">
            <Field
              id="document_back"
              name="document_back"
              type="file"
              component={CustomFileInput}
            />
            <label
              htmlFor="document_back"
              className={classNames('item', { passed: document_back })}
            >
              <span>
                <img src={passportBImageUrl} alt="" />
                <i className="fa fa-check" />
              </span>
              <p>{I18n.t('users.kyc.document_back')}</p>
            </label>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <Field
              id="document_selfie"
              name="document_selfie"
              type="file"
              component={CustomFileInput}
              required
            />
            <label
              htmlFor="document_selfie"
              className={classNames('item', { passed: document_selfie })}
            >
              <span>
                <img src={passportFImageUrl} alt="" />
                <i className="fa fa-check" />
              </span>
              <p>{I18n.t('users.kyc.document_selfie')}</p>
            </label>
          </div>
        </div>
      </div>
      <br />
      <br />
      <Grid container>
        <Grid item xs />
        <Grid item xs={4}>
          <Submit value={I18n.t('users.kyc.submit')} disabled={submitting} />
        </Grid>
        <Grid item xs />
      </Grid>
    </Loading>
  </form>
)

const wrap = body => {
  const fd = new FormData()
  _.each(body, (value, key) => {
    value instanceof FileList ? fd.append(key, value[0]) : fd.append(key, value)
  })
  return fd
}

const validate = values => {
  const errors = {}
  if (values.dob && !/^\d{4}-\d{2}-\d{2}$/.test(values.dob)) {
    errors.dob = <Translate value="users.kyc.date_of_birth_validation_hint" />
  }
  if (values.phone && !/^\+\d{9,15}$/.test(values.phone)) {
    errors.phone = <Translate value="users.kyc.phone_validation_hint" />
  }
  return errors
}

const KycReduxForm = withKyc(
  reduxForm({
    form: 'kyc',
    enableReinitialize: true,
    onSubmit: (props, dispatch, { submitKyc }) =>
      submitKyc(wrap(props)).catch(details => {
        throw new SubmissionError({ ...details, _error: JSON.stringify(details) })
      }),
    validate
  })(KycForm)
)

export default withKyc(Kyc)



// WEBPACK FOOTER //
// ./src/containers/pages/users/kyc/index.js